import { useTranslations } from '@aikoa/i18n/react'
import type { ReactNode } from 'react'
import type { Action } from '~/components/Actions'
import { ActionButton } from '~/components/Actions'
import type { ButtonSize, ButtonVariant } from '~/components/ui/button'
import { Button, ButtonLabel } from '~/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '~/components/ui/dialog'
import { cn } from '~/lib/utils'

export interface InfoModalProps {
  triggerLabel: string
  triggerSize?: ButtonSize
  triggerVariant?: ButtonVariant
  triggerClassName?: string
  closeAction?: Action
  children: ReactNode
  className?: string
}

export function InfoModal({
  triggerLabel,
  triggerSize = 'default',
  triggerVariant = 'outline',
  triggerClassName,
  closeAction,
  children,
  className,
}: InfoModalProps) {
  const { t } = useTranslations('common')

  return (
    <Dialog className="max-w-full">
      <DialogTrigger asChild>
        <Button variant={triggerVariant} size={triggerSize} className={triggerClassName}>
          <ButtonLabel>{triggerLabel}</ButtonLabel>
        </Button>
      </DialogTrigger>
      <DialogContent className={cn('max-w-full gap-6 px-6 py-12', className)}>
        <DialogTitle className="sr-only">{triggerLabel}</DialogTitle>
        {children}
        {closeAction ? (
          <DialogClose asChild>
            <ActionButton action={closeAction} />
          </DialogClose>
        ) : (
          <DialogClose asChild>
            <Button variant="outline">
              <ButtonLabel>{t(($) => $.actions.close)}</ButtonLabel>
            </Button>
          </DialogClose>
        )}
      </DialogContent>
    </Dialog>
  )
}
